import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import Layout from '../../components/Layout';
import Cert from './Cert';
import notFound from '../not-found/index';

import { getCert, reset } from '../../actions/cert';
import {
  isAdmin,
  isWhitelabeledOrganizationAdmin,
  ssrRequest,
} from '../../helpers';
import { getUser } from '../../actions/editUser';

const messages = defineMessages({
  title: {
    id: 'Cert.title',
    defaultMessage: '{name} - Certificate',
    description: 'Title displayed on view cert page',
  },
});

async function action(context) {
  const { store, fetch, params, intl } = context;
  const { code } = params;

  const res = await ssrRequest({
    store,
    fetch,
    getAction: getCert.bind(this, code),
    resetAction: reset,
    context,
  });

  const notFoundReq = _.get(res, 'status') >= 400;

  if (notFoundReq) {
    return notFound(context);
  }

  const { cert, auth } = store.getState();

  const isBundleCert = !!_.get(cert, 'cert.certificateCollectionId');

  if (isBundleCert) {
    await ssrRequest({
      getAction: getUser.bind(
        this,
        _.get(cert, 'cert.userId'),
        isAdmin(auth) || isWhitelabeledOrganizationAdmin(auth),
      ),
      store,
      fetch,
      context,
    });
  }

  const title = intl.formatMessage(messages.title, {
    name: _.get(cert, 'cert.name', ''),
  });

  const isCertPublic = _.get(cert, 'cert.isPublic', false);
  const filePath = _.get(cert, 'cert.file.path', '');
  let imageUrl = null;

  if (!isBundleCert && isCertPublic && filePath) {
    const cloudfrontUrl = _.get(context, 'cloudfrontUrl');
    imageUrl = `${cloudfrontUrl}/${filePath}`;
  }

  return {
    chunks: ['cert'],
    title,
    imageUrl,
    component: (
      <Layout context={context}>
        <Cert data={{}} title={title} />
      </Layout>
    ),
  };
}

export default action;
